const Helpers = {
  share(url) {
    if (!url) {
      return;
    }
    window.open(url, "share", "width=600,height=313");
  },

  array_unique(arr) {
    let result = [];
    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) == -1) {
        result.push(arr[i]);
      }
    }
    return result;
  },

  is_valid_email(email) {
    let pattern = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(email);
  },

  validate(form, scroll = true) {
    let errors = [];

    const fields = form.find(".required").not(".disabled");

    // Check if all required fields are filled
    for (let i = 0; i < fields.length; i++) {
      const input = $(fields[i]);
      let error = false;

      // Check field type
      switch (input.attr("type")) {
        // Email
        case "email":
          if (!input.val() || !Helpers.is_valid_email(input.val())) {
            error = true;
            errors.push(translations.valid_email);
          }
          break;

        // Checkbox, radio
        case "checkbox":
        case "radio":
          if (!input.prop("checked")) {
            error = true;
            errors.push(translations.required);
          }
          break;

        // Text, textarea
        default:
          if (!input.val()) {
            error = true;
            errors.push(translations.required);
          }
      }

      // Handle error class
      if (error) {
        input.addClass("error");
      } else {
        input.removeClass("error");
      }
    }

    // Unique.
    errors = Helpers.array_unique(errors);
    errors.reverse();

    if (scroll && errors.length) {
      // Construct error div.
      let output = '<div class="errors-wrap">';
      for (let i = errors.length - 1; i >= 0; i--) {
        output += errors[i] + "<br />";
      }
      output += "</div>";
      if ($(".errors-wrap").length) {
        $(".errors-wrap").remove();
      }

      // Output errors
      form.prepend(output);

      // Scroll to error
      $("html,body").animate(
        {
          scrollTop: $(".errors-wrap").offset().top - 150,
        },
        1000
      );
    }

    return !errors.length;
  },

  isInViewport(element) {
    const offset = 100;

    const rect = element.getBoundingClientRect();

    return rect.top >= -offset && rect.bottom <= window.innerHeight + offset;
  },
};

export default Helpers;
